/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** DateTime custom scalar type that displays date and time in YYYY-MM-DDTHH:mm:ssZ format */
  DateTime: { input: any; output: any; }
  /** Full Date custom scalar type */
  FullDate: { input: any; output: any; }
  JSON: { input: any; output: any; }
  /** Partial Time custom scalar type */
  PartialTime: { input: any; output: any; }
};

export enum Activity {
  Cruising = 'CRUISING',
  Debark = 'DEBARK',
  Docked = 'DOCKED',
  Embark = 'EMBARK',
  Tendered = 'TENDERED',
  Touring = 'TOURING'
}

export type Agency = {
  __typename?: 'Agency';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AirAccommodation = {
  __typename?: 'AirAccommodation';
  airline?: Maybe<Scalars['String']['output']>;
  arrivalCity?: Maybe<Scalars['String']['output']>;
  arrivalDateTime?: Maybe<Scalars['DateTime']['output']>;
  departureCity?: Maybe<Scalars['String']['output']>;
  departureDateTime?: Maybe<Scalars['DateTime']['output']>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  legNumber?: Maybe<Scalars['Int']['output']>;
  legType?: Maybe<Scalars['String']['output']>;
};

export type AirPrice = {
  __typename?: 'AirPrice';
  currency?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Airline = {
  __typename?: 'Airline';
  code?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Airplane = {
  __typename?: 'Airplane';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Airport = {
  __typename?: 'Airport';
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AirportFilter = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type AirportSort = {
  field: AirportSortableField;
  order?: InputMaybe<SortOrder>;
};

export enum AirportSortableField {
  City = 'CITY',
  Code = 'CODE',
  Name = 'NAME'
}

export type AirportsConnection = {
  __typename?: 'AirportsConnection';
  nodes?: Maybe<Array<Maybe<Airport>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AmendPrice = {
  __typename?: 'AmendPrice';
  balanceDue?: Maybe<Scalars['Float']['output']>;
  balanceDueDate?: Maybe<Scalars['FullDate']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositAmountOwed?: Maybe<Scalars['Float']['output']>;
  depositDueDate?: Maybe<Scalars['FullDate']['output']>;
  depositPaid?: Maybe<Scalars['Boolean']['output']>;
  discounts?: Maybe<Array<Maybe<Discount>>>;
  flightCosts?: Maybe<Scalars['Float']['output']>;
  gratuities?: Maybe<Scalars['Float']['output']>;
  grossTotal?: Maybe<Scalars['Float']['output']>;
  inFinal?: Maybe<Scalars['Boolean']['output']>;
  originalCruiseFare?: Maybe<Scalars['Float']['output']>;
  paymentsApplied?: Maybe<Scalars['Float']['output']>;
  preTour?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  taxesFees?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  /** Total balance due for all staterooms */
  totalBalanceDue?: Maybe<Scalars['Float']['output']>;
  travelProtection?: Maybe<Scalars['Float']['output']>;
};

export enum AplicationSource {
  Air = 'AIR',
  Amend = 'AMEND',
  Confirmation = 'CONFIRMATION'
}

export enum Application {
  Air = 'AIR',
  Amend = 'AMEND',
  Booking = 'BOOKING',
  Common = 'COMMON',
  Confirmation = 'CONFIRMATION',
  UnifiedPayment = 'UNIFIED_PAYMENT'
}

export type AuthorizationInfo = {
  amount: Scalars['Float']['input'];
  authorizationCode: Scalars['String']['input'];
  bookingID: Scalars['String']['input'];
  controlSequenceNumber: Scalars['String']['input'];
  guestID: Scalars['String']['input'];
};

export type AvailableCabins = {
  __typename?: 'AvailableCabins';
  mappedCabin?: Maybe<Scalars['String']['output']>;
  selectedCabin?: Maybe<Scalars['String']['output']>;
};

export type BaggageAllowance = {
  __typename?: 'BaggageAllowance';
  allowanceId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
};

export type BaggageCharge = {
  __typename?: 'BaggageCharge';
  chargeId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<AirPrice>;
};

export type BaggageInfo = {
  __typename?: 'BaggageInfo';
  baggageAllowance?: Maybe<Array<Maybe<BaggageAllowance>>>;
  baggageCharges?: Maybe<Array<Maybe<BaggageCharge>>>;
  freeBaggageCount?: Maybe<Scalars['Int']['output']>;
};

export type Booking = {
  __typename?: 'Booking';
  bookingDate?: Maybe<Scalars['FullDate']['output']>;
  country?: Maybe<Country>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  fareQualifiers?: Maybe<FareQualifiers>;
  flightProfile?: Maybe<FlightProfile>;
  guests?: Maybe<Array<Maybe<Guest>>>;
  id?: Maybe<Scalars['ID']['output']>;
  isCasinoBooking?: Maybe<Scalars['Boolean']['output']>;
  itineraryCode?: Maybe<Scalars['String']['output']>;
  linkedBookings?: Maybe<Array<Maybe<Booking>>>;
  paymentHistory?: Maybe<Array<Maybe<Payment>>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  price?: Maybe<AmendPrice>;
  sailDate?: Maybe<Scalars['FullDate']['output']>;
  sailing?: Maybe<Sailing>;
  startDate?: Maybe<Scalars['FullDate']['output']>;
  stateroom?: Maybe<Stateroom>;
  status?: Maybe<BookingStatus>;
  token?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BookingType>;
  upgradesInfo?: Maybe<UpgradesData>;
};

export type BookingDataInput = {
  bookingId: Scalars['String']['input'];
  info?: InputMaybe<Scalars['JSON']['input']>;
};

export type BookingInput = {
  bookingId: Scalars['String']['input'];
  guest?: InputMaybe<Array<InputMaybe<GuestInput>>>;
};

export type BookingPayload = {
  __typename?: 'BookingPayload';
  booking?: Maybe<Booking>;
  token?: Maybe<Scalars['String']['output']>;
};

export type BookingProfilePayload = {
  __typename?: 'BookingProfilePayload';
  booking?: Maybe<Booking>;
  profileBookings?: Maybe<Array<Maybe<Booking>>>;
  shortProfileBooking?: Maybe<Array<Maybe<ProfileBookingData>>>;
  token?: Maybe<Scalars['String']['output']>;
};

export type BookingProperties = {
  agencyType?: InputMaybe<BookingType>;
  bookingStatus?: InputMaybe<BookingStatus>;
  packages?: InputMaybe<Scalars['String']['input']>;
  shipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum BookingStatus {
  Active = 'ACTIVE',
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  Offered = 'OFFERED',
  Waitlisted = 'WAITLISTED'
}

export enum BookingType {
  Emp = 'EMP',
  Grp = 'GRP',
  Gvs = 'GVS',
  Pbl = 'PBL',
  Ta = 'TA',
  Tb = 'TB',
  Vp = 'VP'
}

export type BooleanPerk = Perk & {
  __typename?: 'BooleanPerk';
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  qualifier?: Maybe<Scalars['String']['output']>;
};


export type BooleanPerkDescriptionArgs = {
  displayQualifier?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Brand {
  Celebrity = 'CELEBRITY',
  Royal = 'ROYAL'
}

export type BrowseFlightSearchFilterInput = {
  arrivalAirportCode?: InputMaybe<Scalars['String']['input']>;
  arrivalDate?: InputMaybe<Scalars['String']['input']>;
  cabinClass?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  departureAirportCode: Scalars['String']['input'];
  departureDate?: InputMaybe<Scalars['String']['input']>;
  numberOfGuests: Scalars['Int']['input'];
  returnArrivalAirportCode?: InputMaybe<Scalars['String']['input']>;
  returnDepartureAirportCode?: InputMaybe<Scalars['String']['input']>;
  sailDate: Scalars['String']['input'];
  shipCode: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BrowseProfileInput = {
  sailDate: Scalars['String']['input'];
  shipCode: Scalars['String']['input'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CampaignsLocale = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type CancelFlightInput = {
  bookingData: BookingInput;
};

export type CancelPenalty = {
  __typename?: 'CancelPenalty';
  amount?: Maybe<Scalars['Float']['output']>;
  isFinalPayment?: Maybe<Scalars['Boolean']['output']>;
  isRefundable?: Maybe<Scalars['Boolean']['output']>;
  isTotalAmount?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * CardTypes allow
 *   AX: American express
 *   DC: Diners Club
 *   DS: Discover (R) Network
 *   JC: Japan credt Bureau
 *   MC: Master Card
 *   VA: Visa
 *   AF: Affirm payment (this will change for VA in the make payment service)
 */
export enum CardType {
  Af = 'AF',
  Ax = 'AX',
  Dc = 'DC',
  Ds = 'DS',
  Jc = 'JC',
  Mc = 'MC',
  Va = 'VA'
}

export type Certificate = {
  __typename?: 'Certificate';
  certificate: Scalars['String']['output'];
  type: CertificateType;
};

export enum CertificateType {
  Active = 'ACTIVE',
  CurrencyMissmatch = 'CURRENCY_MISSMATCH',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Missmatch = 'MISSMATCH',
  NonElegible = 'NON_ELEGIBLE',
  Redeemed = 'REDEEMED',
  Submitted = 'SUBMITTED',
  Updated = 'UPDATED'
}

export type Class = {
  __typename?: 'Class';
  cabinClass?: Maybe<FlightCabinClass>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum ClientApplication {
  Air = 'AIR',
  Amend = 'AMEND',
  BookingFunnel = 'BOOKING_FUNNEL'
}

export enum ContentFocus {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type Country = {
  __typename?: 'Country';
  agency?: Maybe<Agency>;
  bookingFlag?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  currencies?: Maybe<Array<Maybe<Currency>>>;
  defaultCurrency?: Maybe<Currency>;
  defaultLanguage?: Maybe<Language>;
  divisions?: Maybe<Array<Division>>;
  flagPath?: Maybe<Scalars['String']['output']>;
  isoAlpha2Code?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Maybe<Language>>>;
  name?: Maybe<Scalars['String']['output']>;
  office?: Maybe<Office>;
  phoneNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Criteria = {
  __typename?: 'Criteria';
  cabinClass?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  departurePort?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  destination?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ships?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startDate?: Maybe<Array<Maybe<CriteriaDateRange>>>;
  type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CriteriaDateRange = {
  __typename?: 'CriteriaDateRange';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type Cruise = {
  __typename?: 'Cruise';
  displaySailing?: Maybe<Sailing>;
  highlights?: Maybe<Array<Maybe<CruiseHighLight>>>;
  id: Scalars['ID']['output'];
  /** @deprecated All brands and markets support itinerary stacking. */
  legacyType?: Maybe<CruiseLegacyType>;
  lowestPriceSailing?: Maybe<Sailing>;
  masterSailing?: Maybe<Sailing>;
  productViewLink?: Maybe<Scalars['String']['output']>;
  sailings?: Maybe<Array<Maybe<Sailing>>>;
};


export type CruiseDisplaySailingArgs = {
  qualifiers?: InputMaybe<SailingQualifiers>;
};


export type CruiseLowestPriceSailingArgs = {
  qualifiers?: InputMaybe<SailingQualifiers>;
};


export type CruiseSailingsArgs = {
  qualifiers?: InputMaybe<SailingQualifiers>;
};

export type CruiseBasicFilterOption = CruiseListFilterOption & {
  __typename?: 'CruiseBasicFilterOption';
  code: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
};

export type CruiseBooleanFilter = CruiseFilter & {
  __typename?: 'CruiseBooleanFilter';
  facets?: Maybe<Array<Maybe<FacetOption>>>;
  key: Scalars['String']['output'];
};

export type CruiseCustomFilterOption = CruiseListFilterOption & {
  __typename?: 'CruiseCustomFilterOption';
  code: Scalars['String']['output'];
  containers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  criteria?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  urlParams?: Maybe<Array<Maybe<CruiseCustomFilterOptionUrlParam>>>;
};

export type CruiseCustomFilterOptionUrlParam = {
  __typename?: 'CruiseCustomFilterOptionUrlParam';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CruiseDateRangeFilter = CruiseFilter & {
  __typename?: 'CruiseDateRangeFilter';
  endDate?: Maybe<Scalars['FullDate']['output']>;
  facets?: Maybe<Array<Maybe<FacetOption>>>;
  key: Scalars['String']['output'];
  startDate?: Maybe<Scalars['FullDate']['output']>;
};

export type CruiseFilter = {
  facets?: Maybe<Array<Maybe<FacetOption>>>;
  key: Scalars['String']['output'];
};

export type CruiseGroupListFilter = CruiseFilter & {
  __typename?: 'CruiseGroupListFilter';
  facets?: Maybe<Array<Maybe<FacetOption>>>;
  groups?: Maybe<Array<Maybe<CruiseGroupListFilterOption>>>;
  key: Scalars['String']['output'];
};

export type CruiseGroupListFilterOption = {
  __typename?: 'CruiseGroupListFilterOption';
  code: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<CruiseListFilterOption>>>;
};

export type CruiseHighLight = {
  __typename?: 'CruiseHighLight';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  shape?: Maybe<CruiseHighlightShape>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export enum CruiseHighlightShape {
  Inclined = 'inclined',
  Rounded = 'rounded'
}

export enum CruiseLegacyType {
  Group = 'GROUP',
  Package = 'PACKAGE'
}

export type CruiseListFilter = CruiseFilter & {
  __typename?: 'CruiseListFilter';
  facets?: Maybe<Array<Maybe<FacetOption>>>;
  key: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<CruiseListFilterOption>>>;
};

export type CruiseListFilterOption = {
  code: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type CruiseNumberRangeFilter = CruiseFilter & {
  __typename?: 'CruiseNumberRangeFilter';
  facets?: Maybe<Array<Maybe<FacetOption>>>;
  key: Scalars['String']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type CruiseSearch = {
  __typename?: 'CruiseSearch';
  facets?: Maybe<Array<Maybe<Facet>>>;
  filters?: Maybe<Array<Maybe<CruiseFilter>>>;
  results?: Maybe<CruiseSearchResults>;
};

export type CruiseSearchPagination = {
  count?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CruiseSearchResults = {
  __typename?: 'CruiseSearchResults';
  cruiseRecommendationId?: Maybe<Scalars['String']['output']>;
  cruises?: Maybe<Array<Maybe<Cruise>>>;
  nlFilters?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CruiseSearchSort = {
  by?: InputMaybe<CruiseSearchSortField>;
  order?: InputMaybe<CruiseSearchSortOrder>;
};

export enum CruiseSearchSortField {
  Nights = 'NIGHTS',
  Price = 'PRICE',
  Recommended = 'RECOMMENDED',
  Saildate = 'SAILDATE'
}

export enum CruiseSearchSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type CruiseSortFilterOption = CruiseListFilterOption & {
  __typename?: 'CruiseSortFilterOption';
  attribute: Scalars['String']['output'];
  code: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  decimalSeparator?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  symbolOnLeft?: Maybe<Scalars['Boolean']['output']>;
  thousandsSeparator?: Maybe<Scalars['String']['output']>;
};

export type DateRange = {
  __typename?: 'DateRange';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type Day = {
  __typename?: 'Day';
  number?: Maybe<Scalars['Int']['output']>;
  ports?: Maybe<Array<Maybe<PortVisit>>>;
  type?: Maybe<DayType>;
};

export enum DayType {
  Cruising = 'CRUISING',
  CruisingInternationalDateLine = 'CRUISING_INTERNATIONAL_DATE_LINE',
  MultiPort = 'MULTI_PORT',
  Port = 'PORT',
  PortTour = 'PORT_TOUR',
  Tour = 'TOUR'
}

export type Deck = {
  __typename?: 'Deck';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Destination = {
  __typename?: 'Destination';
  code?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Float']['output']>;
  bfPromotionCodes?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fareCode?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Promotion>;
};

export type Division = {
  __typename?: 'Division';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DynamicPricePerk = Perk & {
  __typename?: 'DynamicPricePerk';
  defaultPrice?: Maybe<Price>;
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  search?: Maybe<Scalars['String']['output']>;
};


export type DynamicPricePerkDescriptionArgs = {
  displayQualifier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EncodedBookingPayload = {
  __typename?: 'EncodedBookingPayload';
  booking?: Maybe<Booking>;
  bookingInput?: Maybe<Scalars['JSON']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type ExtendHoldResponse = {
  __typename?: 'ExtendHoldResponse';
  correlationID?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Facet = {
  __typename?: 'Facet';
  key: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<FacetOption>>>;
};

export type FacetOption = {
  __typename?: 'FacetOption';
  code: Scalars['String']['output'];
  count?: Maybe<Scalars['Int']['output']>;
};

export type FareQualifiers = {
  __typename?: 'FareQualifiers';
  fireFighterReqd?: Maybe<Scalars['Boolean']['output']>;
  militaryReqd?: Maybe<Scalars['Boolean']['output']>;
  policeReqd?: Maybe<Scalars['Boolean']['output']>;
  seniorReqd?: Maybe<Scalars['Boolean']['output']>;
};

export type Filters = {
  code?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<PromotionType>>>;
};

export type Flag = {
  default?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Flight = {
  __typename?: 'Flight';
  arrivalDate?: Maybe<Scalars['String']['output']>;
  arrivalTime?: Maybe<Scalars['String']['output']>;
  confirmationNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  departDate?: Maybe<Scalars['String']['output']>;
  departTime?: Maybe<Scalars['String']['output']>;
  flightIcon?: Maybe<Scalars['String']['output']>;
  flightSegments?: Maybe<Array<Maybe<FlightSegment>>>;
  gdsLocator?: Maybe<Scalars['String']['output']>;
  numberOfStops?: Maybe<Scalars['Int']['output']>;
  routeDirection?: Maybe<Scalars['String']['output']>;
  totalDurationMins?: Maybe<Scalars['Int']['output']>;
  totalLayoverMins?: Maybe<Scalars['Int']['output']>;
};

export type FlightBooking = {
  __typename?: 'FlightBooking';
  finalPaymentDate?: Maybe<Scalars['FullDate']['output']>;
};

export type FlightCabinClass = {
  __typename?: 'FlightCabinClass';
  code: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FlightDetail = {
  __typename?: 'FlightDetail';
  baggageInfo?: Maybe<BaggageInfo>;
  cabinClass?: Maybe<FlightCabinClass>;
  currency?: Maybe<Scalars['String']['output']>;
  hashKey?: Maybe<Scalars['String']['output']>;
  inflightServices?: Maybe<Array<Maybe<InflightService>>>;
  isMixedCabin?: Maybe<Scalars['Boolean']['output']>;
  isPaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  isRefundable?: Maybe<Scalars['Boolean']['output']>;
  passengerQty?: Maybe<Scalars['Int']['output']>;
  pricePerPassenger?: Maybe<AirPrice>;
  seatsAvailable?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<AirPrice>;
  wasPricePerPassenger?: Maybe<AirPrice>;
  wasTotalPrice?: Maybe<AirPrice>;
};

export type FlightFilters = {
  __typename?: 'FlightFilters';
  airlines?: Maybe<Array<Maybe<Airline>>>;
  classes: Array<Maybe<Class>>;
  flightTimes: FlightTimes;
  minMaxPrice: MinMaxPrice;
  stops: Stops;
};

export type FlightGuest = {
  __typename?: 'FlightGuest';
  age?: Maybe<Scalars['Int']['output']>;
  airChargesAmount?: Maybe<Scalars['Float']['output']>;
  airFee?: Maybe<Scalars['Float']['output']>;
  airFeeAfterDueDate?: Maybe<Scalars['Float']['output']>;
  airPenaltyAmount?: Maybe<Scalars['Float']['output']>;
  allowCancellation?: Maybe<Scalars['Boolean']['output']>;
  allowReshop?: Maybe<Scalars['Boolean']['output']>;
  cancelationPenalities?: Maybe<Array<Maybe<CancelPenalty>>>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gdsLocators?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  gender?: Maybe<Scalars['String']['output']>;
  guestFlights?: Maybe<Array<Maybe<Flight>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['FullDate']['output']>;
  refundableFlag?: Maybe<Scalars['Boolean']['output']>;
  transfers?: Maybe<Array<Maybe<TransferData>>>;
};

export enum FlightPassengerType {
  Adult = 'ADULT',
  Child = 'CHILD',
  Infant = 'INFANT'
}

export type FlightProfile = {
  __typename?: 'FlightProfile';
  booking?: Maybe<FlightBooking>;
  currency?: Maybe<Scalars['String']['output']>;
  flightWindows?: Maybe<FlightWindow>;
  guests?: Maybe<Array<Maybe<Guest>>>;
  id: Scalars['ID']['output'];
  nearByAirports?: Maybe<Array<Maybe<NearAirport>>>;
  nearestAirport?: Maybe<NearestAirport>;
  officeId?: Maybe<Scalars['String']['output']>;
  sailing?: Maybe<FlightSailing>;
};

export type FlightRouteType = {
  __typename?: 'FlightRouteType';
  code: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FlightSailing = {
  __typename?: 'FlightSailing';
  finalPaymentDate?: Maybe<Scalars['FullDate']['output']>;
  returnDate?: Maybe<Scalars['String']['output']>;
  returnTime?: Maybe<Scalars['String']['output']>;
  sailDate?: Maybe<Scalars['String']['output']>;
  sailTime?: Maybe<Scalars['String']['output']>;
  shipCode?: Maybe<Scalars['String']['output']>;
};

export type FlightSearchFilterInput = {
  /** [Required] Airport code of the airport arriving to before the cruise (i.e. cruise port) */
  arrivalAirportCode?: InputMaybe<Scalars['String']['input']>;
  /** [Required] Date to arrive before the cruise */
  arrivalDate?: InputMaybe<Scalars['String']['input']>;
  /** [Required] Id of the cruise booking */
  bookingID: Scalars['String']['input'];
  /** [Optional] Filter results by cabin class */
  cabinClass?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Generate results using specified currency; defaults to USD */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** [Required] Airport code of the airport departing from before the cruise (i.e. home) */
  departureAirportCode: Scalars['String']['input'];
  /** [Required] Date to depart after the cruise */
  departureDate?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Array of guest ids; Required if numberOfGuests is empty */
  guestIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  guests?: InputMaybe<Array<InputMaybe<HeldConfirmGuestInput>>>;
  mode?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Number of guests in inqury; Required if guestIDs is empty */
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  /** [Optional] Airport code of the airport arriving to after the cruise (i.e. home); defaults to departureAirportCode */
  returnArrivalAirportCode?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Airport code of the airport departing from after the cruise (i.e. cruise port); defaults to arrivalAirportCode */
  returnDepartureAirportCode?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Parameter to manage one way  */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FlightSearchResult = {
  __typename?: 'FlightSearchResult';
  correlationID: Scalars['String']['output'];
  flightFilters?: Maybe<FlightFilters>;
  matchingFlights?: Maybe<Array<Maybe<MatchingFlight>>>;
  shipBrowseFlight?: Maybe<ShipBrowseFlight>;
};

export type FlightSegment = {
  __typename?: 'FlightSegment';
  airplane?: Maybe<Airplane>;
  arrival?: Maybe<OutboundFlight>;
  availableCabins?: Maybe<Array<Maybe<AvailableCabins>>>;
  cabinClass?: Maybe<FlightCabinClass>;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  departure?: Maybe<OutboundFlight>;
  durationMins?: Maybe<Scalars['Int']['output']>;
  layoverMins?: Maybe<Scalars['Int']['output']>;
  marketingAirline?: Maybe<Airline>;
  number?: Maybe<Scalars['String']['output']>;
  operatingAirline?: Maybe<Airline>;
  segmentId?: Maybe<Scalars['Int']['output']>;
};

export type FlightTime = {
  __typename?: 'FlightTime';
  maxDateTime: Scalars['String']['output'];
  minDateTime: Scalars['String']['output'];
};

export type FlightTimes = {
  __typename?: 'FlightTimes';
  landing: FlightTime;
  takeOff: FlightTime;
};

export type FlightWindow = {
  __typename?: 'FlightWindow';
  arrival?: Maybe<FlightWindowArrival>;
  departure?: Maybe<FlightWindowDeparture>;
};

export type FlightWindowArrival = {
  __typename?: 'FlightWindowArrival';
  earliestDate: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  latestDate: Scalars['String']['output'];
};

export type FlightWindowDeparture = {
  __typename?: 'FlightWindowDeparture';
  earliestDate: Scalars['String']['output'];
  latestDate: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type FrequentFlyerInput = {
  frequentFlyerNumber?: InputMaybe<Scalars['String']['input']>;
  frequentFlyerProgram?: InputMaybe<Scalars['String']['input']>;
};

export type FutureCruiseCreditInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  futureCruiseCredits: Array<Scalars['String']['input']>;
};

export enum Gender {
  F = 'F',
  M = 'M'
}

export type GiftCardInput = {
  accountNumber: Scalars['String']['input'];
  cvv2: Scalars['String']['input'];
  expirationDate: Scalars['String']['input'];
};

export type GiftCardPayload = {
  __typename?: 'GiftCardPayload';
  accountNumber?: Maybe<Scalars['String']['output']>;
  activationAmount?: Maybe<Scalars['Float']['output']>;
  balanceResponse?: Maybe<Scalars['String']['output']>;
  price?: Maybe<AirPrice>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Guest = {
  __typename?: 'Guest';
  _mutableFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  age?: Maybe<Scalars['Int']['output']>;
  airAccommodations?: Maybe<Array<Maybe<AirAccommodation>>>;
  birthDate?: Maybe<Scalars['FullDate']['output']>;
  booking?: Maybe<Booking>;
  cas?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flightGuest?: Maybe<FlightGuest>;
  flightPassengerType?: Maybe<FlightPassengerType>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['ID']['output']>;
  index: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  travelDocument?: Maybe<Scalars['String']['output']>;
};

export type GuestAirProfileInput = {
  bookingId: Scalars['String']['input'];
  correlationID?: InputMaybe<Scalars['String']['input']>;
  guestIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locators?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GuestInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  gdsLocators?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guestID?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type HeldConfirmGuestInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  frequentFlyer?: InputMaybe<Array<InputMaybe<FrequentFlyerInput>>>;
  id: Scalars['ID']['input'];
  knownTravelerNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  redressNumber?: InputMaybe<Scalars['String']['input']>;
};

export type HeldConfirmInput = {
  bookingID: Scalars['String']['input'];
  correlationID: Scalars['String']['input'];
  guests: Array<InputMaybe<HeldConfirmGuestInput>>;
  hashKey: Scalars['String']['input'];
};

export type HoldReservationInput = {
  bookingID?: InputMaybe<Scalars['String']['input']>;
  correlationID: Scalars['String']['input'];
  guests?: InputMaybe<Array<InputMaybe<HeldConfirmGuestInput>>>;
  hashKey: Scalars['String']['input'];
};

export type HoldReservationResponse = {
  __typename?: 'HoldReservationResponse';
  correlationID: Scalars['String']['output'];
  hasFlights?: Maybe<Scalars['Boolean']['output']>;
  inboundFlight?: Maybe<Flight>;
  outboundFlight?: Maybe<Flight>;
  priceChange?: Maybe<PriceChange>;
  warnings?: Maybe<Array<Maybe<WarningMessage>>>;
};

export type Image = {
  __typename?: 'Image';
  key?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ImageType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ImageMedia = {
  __typename?: 'ImageMedia';
  meta?: Maybe<ImageMeta>;
  path: Scalars['String']['output'];
};

export type ImageMediaQualifiers = {
  size?: InputMaybe<ImageSize>;
};

export type ImageMeta = {
  __typename?: 'ImageMeta';
  description?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ImageSize = {
  h?: InputMaybe<Scalars['Int']['input']>;
  w?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSizes = {
  key?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export enum ImageType {
  Hero = 'HERO',
  Thumbnail = 'THUMBNAIL'
}

export type InflightService = {
  __typename?: 'InflightService';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Itinerary = {
  __typename?: 'Itinerary';
  code: Scalars['String']['output'];
  days?: Maybe<Array<Maybe<Day>>>;
  departurePort?: Maybe<Port>;
  description?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Destination>;
  groupId: Scalars['String']['output'];
  media?: Maybe<Media>;
  name?: Maybe<Scalars['String']['output']>;
  portSequence?: Maybe<Scalars['String']['output']>;
  postTour?: Maybe<Tour>;
  preTour?: Maybe<Tour>;
  sailingNights?: Maybe<Scalars['Int']['output']>;
  ship?: Maybe<Ship>;
  totalNights?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ItineraryType>;
  urgencyFlags?: Maybe<Array<Maybe<UrgencyFlags>>>;
  voyageType?: Maybe<ItineraryVoyageType>;
};

export enum ItineraryType {
  Cruise = 'CRUISE',
  Cruisetour = 'CRUISETOUR'
}

export enum ItineraryVoyageType {
  Ocean = 'OCEAN',
  River = 'RIVER'
}

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
};

export enum Layout {
  Banner = 'banner',
  Billboard = 'billboard',
  Hero = 'hero',
  Jumbotron = 'jumbotron',
  Leaderboard = 'leaderboard',
  Polyvision = 'polyvision',
  Portrait = 'portrait',
  Poster = 'poster',
  Square = 'square',
  VerticalBanner = 'vertical_banner'
}

export type LiteProfileData = {
  __typename?: 'LiteProfileData';
  creationDate?: Maybe<Scalars['String']['output']>;
  crownAnaAnchorId?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  loyaltyData?: Maybe<Scalars['String']['output']>;
  loyaltyLevel?: Maybe<Scalars['String']['output']>;
  loyaltyPoints?: Maybe<Scalars['Int']['output']>;
  loyaltyTier?: Maybe<Scalars['String']['output']>;
  mkCloudId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Locale = {
  __typename?: 'Locale';
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  currency?: Maybe<Currency>;
  id: Scalars['String']['output'];
  language?: Maybe<Language>;
  market?: Maybe<Market>;
  path?: Maybe<Scalars['String']['output']>;
  seoCode?: Maybe<Scalars['String']['output']>;
  siteSearchCustomId?: Maybe<Scalars['String']['output']>;
};

export type Lockup = {
  __typename?: 'Lockup';
  desktop?: Maybe<PromotionImage>;
  mobile?: Maybe<PromotionImage>;
};

export type LoyaltyInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cas: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type MakePaymentInput = {
  amount: Scalars['Float']['input'];
  authentication?: InputMaybe<Scalars['String']['input']>;
  cardNumber: Scalars['String']['input'];
  cardType: CardType;
  cvv?: InputMaybe<Scalars['String']['input']>;
  /** Credit card expiration date as MMYY */
  expiration: Scalars['String']['input'];
  firstNameOnCard?: InputMaybe<Scalars['String']['input']>;
  isThreeDsEligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameOnCard?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethod;
};

export type MakePaymentPayload = {
  __typename?: 'MakePaymentPayload';
  paymentAmount: Scalars['Float']['output'];
  remainingBalance: Scalars['Float']['output'];
};

export type Market = {
  __typename?: 'Market';
  code: Scalars['String']['output'];
  contentPath?: Maybe<Scalars['String']['output']>;
  countries?: Maybe<Array<Maybe<Country>>>;
  defaultCountry?: Maybe<Country>;
  defaultLanguage?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Array<Maybe<Language>>>;
  localeLanguage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MarketingScript = {
  __typename?: 'MarketingScript';
  async?: Maybe<Scalars['Boolean']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MatchingFlight = {
  __typename?: 'MatchingFlight';
  arrivalDate?: Maybe<Scalars['String']['output']>;
  arrivalTime?: Maybe<Scalars['String']['output']>;
  departDate?: Maybe<Scalars['String']['output']>;
  departTime?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<Maybe<FlightDetail>>>;
  flightIcon?: Maybe<Scalars['String']['output']>;
  flightSegments?: Maybe<Array<Maybe<FlightSegment>>>;
  lowestAvailableFare?: Maybe<AirPrice>;
  operatingAirlines?: Maybe<Array<Maybe<Airline>>>;
  routeId?: Maybe<Scalars['Int']['output']>;
  routeType?: Maybe<FlightRouteType>;
  totalDurationMins?: Maybe<Scalars['Int']['output']>;
};

export type Media = {
  __typename?: 'Media';
  images?: Maybe<Array<Maybe<ImageMedia>>>;
};


export type MediaImagesArgs = {
  qualifiers?: InputMaybe<Array<InputMaybe<ImageMediaQualifiers>>>;
};

export type MinMaxPrice = {
  __typename?: 'MinMaxPrice';
  max?: Maybe<AirPrice>;
  min?: Maybe<AirPrice>;
};

export type Mutation = {
  __typename?: 'Mutation';
  bookFlight?: Maybe<HoldReservationResponse>;
  bookFlightAuthorization?: Maybe<HoldReservationResponse>;
  cancelFlight?: Maybe<Scalars['String']['output']>;
  extendHoldSession?: Maybe<ExtendHoldResponse>;
  holdFlight?: Maybe<HoldReservationResponse>;
  logData?: Maybe<Scalars['JSON']['output']>;
  makePayment?: Maybe<MakePaymentPayload>;
  /** Submits an array of future cruise credit values for a booking */
  submitFutureCruiseCredits?: Maybe<Array<Certificate>>;
  /** Invokes an update on a booking to force backend systems to populate with correct values (i.e. booking status) */
  triggerBookingUpdate?: Maybe<Booking>;
  /** Updates the personal information for the guests */
  updateGuestInformation?: Maybe<Booking>;
  validateCas?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationBookFlightArgs = {
  heldConfirmInput: HeldConfirmInput;
  paymentInput?: InputMaybe<Array<InputMaybe<PaymentInput>>>;
};


export type MutationBookFlightAuthorizationArgs = {
  authorizationInfo?: InputMaybe<Array<InputMaybe<AuthorizationInfo>>>;
  heldConfirmInput: HeldConfirmInput;
};


export type MutationCancelFlightArgs = {
  input?: InputMaybe<CancelFlightInput>;
};


export type MutationExtendHoldSessionArgs = {
  input?: InputMaybe<HoldReservationInput>;
};


export type MutationHoldFlightArgs = {
  input?: InputMaybe<HoldReservationInput>;
};


export type MutationLogDataArgs = {
  input: BookingDataInput;
};


export type MutationMakePaymentArgs = {
  input: Array<MakePaymentInput>;
};


export type MutationSubmitFutureCruiseCreditsArgs = {
  input: FutureCruiseCreditInput;
};


export type MutationTriggerBookingUpdateArgs = {
  initializedFromEmail?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<RetrieveBookingInput>;
};


export type MutationUpdateGuestInformationArgs = {
  input: Array<UpdateGuestInformationInput>;
};


export type MutationValidateCasArgs = {
  input?: InputMaybe<LoyaltyInput>;
};

export type NearAirport = {
  __typename?: 'NearAirport';
  airportCode?: Maybe<Scalars['String']['output']>;
  nearByAirports?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NearestAirport = {
  __typename?: 'NearestAirport';
  arrival?: Maybe<Airport>;
  departure?: Maybe<Airport>;
};

export type Office = {
  __typename?: 'Office';
  code: Scalars['String']['output'];
};

export type OutboundFlight = {
  __typename?: 'OutboundFlight';
  airport?: Maybe<Airport>;
  date?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Float']['output']>;
  creationDate?: Maybe<Scalars['FullDate']['output']>;
  creationTime?: Maybe<Scalars['PartialTime']['output']>;
  /** @deprecated Use creationDate */
  date?: Maybe<Scalars['FullDate']['output']>;
  postedDate?: Maybe<Scalars['FullDate']['output']>;
  postedTime?: Maybe<Scalars['PartialTime']['output']>;
  status?: Maybe<PaymentStatus>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentInput = {
  amount: Scalars['Float']['input'];
  authentication?: InputMaybe<Scalars['String']['input']>;
  cardNumber: Scalars['String']['input'];
  cardType: CardType;
  cvv?: InputMaybe<Scalars['String']['input']>;
  /** Credit card expiration date as MMYY */
  expiration: Scalars['String']['input'];
  firstNameOnCard?: InputMaybe<Scalars['String']['input']>;
  isThreeDsEligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameOnCard?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethod;
};

/**
 * PaymentMethods allow
 *   GC: Gift Card
 *   CC: Credit Card
 */
export enum PaymentMethod {
  Cc = 'CC',
  Gc = 'GC'
}

/**
 * Payment Statuses allowed
 *   PEN: Pending (credit card entered but not authorized)
 *   PRG: Purged
 *   PST: Posted
 *   REC: Received, not posted
 *   WRK: Work transaction (error/work batch)
 */
export enum PaymentStatus {
  Pen = 'PEN',
  Prg = 'PRG',
  Pst = 'PST',
  Rec = 'REC',
  Wrk = 'WRK'
}

export enum PaymentType {
  Payments = 'PAYMENTS',
  Total = 'TOTAL'
}

export type PencilBannerContent = {
  __typename?: 'PencilBannerContent';
  campaignId?: Maybe<Scalars['String']['output']>;
  countdownLabel?: Maybe<Scalars['String']['output']>;
  countdownStartdate?: Maybe<Scalars['String']['output']>;
  data?: Maybe<PencilBannerContentData>;
  isCountdownEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFlagEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSticky?: Maybe<Scalars['Boolean']['output']>;
  isSubscribeToPromotions?: Maybe<Scalars['Boolean']['output']>;
  perks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  promotionCountdownEnabled?: Maybe<Scalars['Boolean']['output']>;
  promotionCountdownFlipDaysDate?: Maybe<Scalars['String']['output']>;
  promotionCountdownStartDate?: Maybe<Scalars['String']['output']>;
  promotionEndDate?: Maybe<Scalars['String']['output']>;
  promotionExtended?: Maybe<Scalars['Boolean']['output']>;
  promotionUiAttributes?: Maybe<PencilBannerPromotionUiAttributes>;
};

export type PencilBannerContentData = {
  __typename?: 'PencilBannerContentData';
  flagBackgroundColor?: Maybe<Scalars['String']['output']>;
  flagText?: Maybe<Scalars['String']['output']>;
  flagTextColor?: Maybe<Scalars['String']['output']>;
  isFlagEnabled?: Maybe<Scalars['Boolean']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type PencilBannerFilters = {
  code?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<PromotionType>>>;
};

export type PencilBannerLocale = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type PencilBannerPromotionUiAttributes = {
  __typename?: 'PencilBannerPromotionUiAttributes';
  countdownBackgroundColor?: Maybe<Scalars['String']['output']>;
  countdownTextColor?: Maybe<Scalars['String']['output']>;
};

export type PencilBannerUiAttributes = {
  __typename?: 'PencilBannerUIAttributes';
  bannerBackgroundColor?: Maybe<Scalars['String']['output']>;
  bannerTextColor?: Maybe<Scalars['String']['output']>;
  countdownBackgroundColor?: Maybe<Scalars['String']['output']>;
  countdownTextColor?: Maybe<Scalars['String']['output']>;
  ctaBackgroundColor?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaTextColor?: Maybe<Scalars['String']['output']>;
};

export type PencilBannerVariation = {
  __typename?: 'PencilBannerVariation';
  brand?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<PencilBannerContent>;
  contentExpirationDate?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  globalEndDate?: Maybe<Scalars['String']['output']>;
  globalStartDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pencilBannerId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetPages?: Maybe<TargetPages>;
  uiAttributes?: Maybe<PencilBannerUiAttributes>;
};

export type PercentOffPerk = Perk & {
  __typename?: 'PercentOffPerk';
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Int']['output']>;
  qualifier?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
};


export type PercentOffPerkDescriptionArgs = {
  displayQualifier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Perk = {
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};


export type PerkDescriptionArgs = {
  displayQualifier?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PerkSortType {
  Order = 'order',
  Price = 'price'
}

export type Port = {
  __typename?: 'Port';
  code: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type PortTemp = {
  __typename?: 'PortTemp';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type PortVisit = {
  __typename?: 'PortVisit';
  activity?: Maybe<Activity>;
  arrivalTime?: Maybe<Scalars['PartialTime']['output']>;
  departureTime?: Maybe<Scalars['PartialTime']['output']>;
  port?: Maybe<Port>;
};

export type Price = {
  __typename?: 'Price';
  currency?: Maybe<Currency>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PriceChange = {
  __typename?: 'PriceChange';
  newTotal?: Maybe<AirPrice>;
  pricePerPassenger?: Maybe<AirPrice>;
};

export type PricePerk = Perk & {
  __typename?: 'PricePerk';
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Price>;
  qualifier?: Maybe<Scalars['String']['output']>;
};


export type PricePerkDescriptionArgs = {
  displayQualifier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Promotion = {
  __typename?: 'Promotion';
  brand?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contentExpirationDate?: Maybe<Scalars['String']['output']>;
  countdownEnabled?: Maybe<Scalars['Boolean']['output']>;
  countdownFlipDaysDate?: Maybe<Scalars['String']['output']>;
  countdownStartDate?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  criteria?: Maybe<Array<Maybe<Criteria>>>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  extended?: Maybe<Scalars['Boolean']['output']>;
  fareCode?: Maybe<Scalars['String']['output']>;
  fareCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalEndDate?: Maybe<Scalars['String']['output']>;
  globalStartDate?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lockup?: Maybe<Lockup>;
  media?: Maybe<PromotionMedia>;
  otherCampaignType?: Maybe<Scalars['String']['output']>;
  perks?: Maybe<Array<Maybe<Perk>>>;
  restrictedUsage?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<TermsAndConditions>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PromotionType>;
  uiAttributes?: Maybe<UiAttributes>;
  uniqueCouponCode?: Maybe<Scalars['Boolean']['output']>;
};


export type PromotionPerksArgs = {
  sort?: InputMaybe<Array<InputMaybe<PerkSortType>>>;
};

export type PromotionImage = {
  __typename?: 'PromotionImage';
  darkenFilter?: Maybe<Scalars['Boolean']['output']>;
  darkenFilterColor?: Maybe<Scalars['String']['output']>;
  darkenFilterCover?: Maybe<Scalars['Int']['output']>;
  darkenFilterOpacity?: Maybe<Scalars['Int']['output']>;
  darkenFilterOrientation?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Layout>;
  path?: Maybe<Scalars['String']['output']>;
  relativePath?: Maybe<Scalars['String']['output']>;
  textAlignment?: Maybe<Scalars['String']['output']>;
  textPlacementZone?: Maybe<Scalars['Boolean']['output']>;
  videoAspectRatio?: Maybe<Scalars['String']['output']>;
  videoDarkenFilter?: Maybe<Scalars['Boolean']['output']>;
  videoDarkenFilterColor?: Maybe<Scalars['String']['output']>;
  videoDarkenFilterCover?: Maybe<Scalars['Int']['output']>;
  videoDarkenFilterOpacity?: Maybe<Scalars['Int']['output']>;
  videoDarkenFilterOrientation?: Maybe<Scalars['String']['output']>;
  videoPath?: Maybe<Scalars['String']['output']>;
};

export type PromotionMedia = {
  __typename?: 'PromotionMedia';
  images?: Maybe<Array<Maybe<PromotionImage>>>;
};


export type PromotionMediaImagesArgs = {
  qualifiers?: InputMaybe<Array<InputMaybe<PromotionMediaQualifier>>>;
};

export type PromotionMediaQualifier = {
  key?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Layout>;
};

export enum PromotionType {
  Casino = 'casino',
  FlashSale = 'flash_sale',
  GoingGoingGone = 'going_going_gone',
  Kicker = 'kicker',
  KidsSailFree = 'kids_sail_free',
  Monthly = 'monthly',
  RefundableDepositAddOn = 'refundable_deposit_add_on',
  SuperSale = 'super_sale',
  TargetedOffer = 'targeted_offer'
}

export type Query = {
  __typename?: 'Query';
  aemConfig?: Maybe<Scalars['String']['output']>;
  airline?: Maybe<Airline>;
  airport?: Maybe<Airport>;
  airports?: Maybe<AirportsConnection>;
  allCountries?: Maybe<Array<Maybe<Country>>>;
  bestPencilBannerVariationForMarket?: Maybe<PencilBannerVariation>;
  bestPromotionForMarket?: Maybe<Promotion>;
  browseFlightProfile?: Maybe<FlightProfile>;
  browseFlightsSearch?: Maybe<FlightSearchResult>;
  cruise?: Maybe<Cruise>;
  cruiseSearch?: Maybe<CruiseSearch>;
  currentBooking?: Maybe<Booking>;
  encrypt?: Maybe<Scalars['String']['output']>;
  flightCabinClasses?: Maybe<Array<Maybe<FlightCabinClass>>>;
  flightProfile?: Maybe<FlightProfile>;
  flightRouteTypes?: Maybe<Array<Maybe<FlightRouteType>>>;
  flightsSearch?: Maybe<FlightSearchResult>;
  getLiteProfile?: Maybe<LiteProfileData>;
  giftCardBalanceInquiry?: Maybe<GiftCardPayload>;
  guestAirProfile?: Maybe<HoldReservationResponse>;
  itinerary?: Maybe<Itinerary>;
  ldAirFlags?: Maybe<Scalars['JSON']['output']>;
  ldFlags?: Maybe<Scalars['JSON']['output']>;
  locale?: Maybe<Locale>;
  locales?: Maybe<Array<Maybe<Locale>>>;
  markets?: Maybe<Array<Maybe<Market>>>;
  paymentHistory?: Maybe<Array<Maybe<Payment>>>;
  pencilBannerVariations?: Maybe<Array<Maybe<PencilBannerVariation>>>;
  port?: Maybe<Port>;
  /** @deprecated Use Port from rccl-apollo-service-cruises */
  portTemp?: Maybe<PortTemp>;
  ports?: Maybe<Array<Maybe<Port>>>;
  /** @deprecated Use Port from rccl-apollo-service-cruises */
  portsTemp?: Maybe<Array<PortTemp>>;
  promotionByCampaignId?: Maybe<Promotion>;
  promotions?: Maybe<Array<Maybe<Promotion>>>;
  retrieveBooking?: Maybe<RetrieveBookingPayload>;
  retrieveBookingByGAProfile?: Maybe<BookingProfilePayload>;
  retrieveBookingsByProfile?: Maybe<Array<Maybe<Booking>>>;
  retrieveEncodedBooking?: Maybe<Array<Maybe<EncodedBookingPayload>>>;
  retrieveEncryptedBooking?: Maybe<BookingPayload>;
  returnFlightsSearch?: Maybe<FlightSearchResult>;
  sailing?: Maybe<Sailing>;
  searchPackageCodeByCruiseInfo?: Maybe<Scalars['String']['output']>;
  searchSailingByBookingInfo?: Maybe<SailingByBookingResponse>;
  searchSailings?: Maybe<SearchSailingsResponse>;
  ship?: Maybe<Ship>;
  ships?: Maybe<Array<Maybe<Ship>>>;
  stateroom?: Maybe<Stateroom>;
  targetedOffers?: Maybe<Array<Maybe<Promotion>>>;
  variationByPencilBannerId?: Maybe<PencilBannerVariation>;
};


export type QueryAemConfigArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAirlineArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAirportArgs = {
  code: Scalars['String']['input'];
};


export type QueryAirportsArgs = {
  filter?: InputMaybe<AirportFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AirportSort>>;
};


export type QueryBestPencilBannerVariationForMarketArgs = {
  datetime?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PencilBannerFilters>;
  locale?: InputMaybe<PencilBannerLocale>;
  pagePath?: InputMaybe<Scalars['String']['input']>;
  previewId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBestPromotionForMarketArgs = {
  datetime?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Filters>;
  locale?: InputMaybe<CampaignsLocale>;
  previewId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBrowseFlightProfileArgs = {
  input?: InputMaybe<BrowseProfileInput>;
};


export type QueryBrowseFlightsSearchArgs = {
  input?: InputMaybe<BrowseFlightSearchFilterInput>;
};


export type QueryCruiseArgs = {
  filters?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  qualifiers?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCruiseSearchArgs = {
  filters?: InputMaybe<Scalars['String']['input']>;
  nlSearch?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<CruiseSearchPagination>;
  qualifiers?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<CruiseSearchSort>;
};


export type QueryCurrentBookingArgs = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEncryptArgs = {
  object?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFlightProfileArgs = {
  ignoreCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFlightsSearchArgs = {
  input?: InputMaybe<FlightSearchFilterInput>;
};


export type QueryGiftCardBalanceInquiryArgs = {
  input: GiftCardInput;
};


export type QueryGuestAirProfileArgs = {
  input?: InputMaybe<GuestAirProfileInput>;
};


export type QueryItineraryArgs = {
  packageId?: InputMaybe<Scalars['String']['input']>;
  sailDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLdAirFlagsArgs = {
  bookingCountry?: InputMaybe<Scalars['String']['input']>;
  ldUser: Scalars['String']['input'];
  officeID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLdFlagsArgs = {
  adobeTarget?: InputMaybe<Scalars['String']['input']>;
  application?: InputMaybe<Application>;
  bookingCountry?: InputMaybe<Scalars['String']['input']>;
  bookingProperties?: InputMaybe<BookingProperties>;
  brand?: InputMaybe<Brand>;
  clientApp?: InputMaybe<ClientApplication>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  defaultFlags?: InputMaybe<Array<InputMaybe<Flag>>>;
  flag?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  ldUser: Scalars['String']['input'];
  numberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  officeID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocaleArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isoAlpha2Code?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentHistoryArgs = {
  bookingAccessToken?: InputMaybe<Scalars['String']['input']>;
  bookingId: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  sailDate: Scalars['String']['input'];
  shipCode: Scalars['String']['input'];
};


export type QueryPencilBannerVariationsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  datetime?: InputMaybe<Scalars['String']['input']>;
  pencilBannerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortArgs = {
  portCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortTempArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortsArgs = {
  portCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPromotionByCampaignIdArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  datetime?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<CampaignsLocale>;
  previewId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPromotionsArgs = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  datetime?: InputMaybe<Scalars['String']['input']>;
  fareCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryRetrieveBookingArgs = {
  input: RetrieveBookingInput;
};


export type QueryRetrieveBookingByGaProfileArgs = {
  accessToken: Scalars['String']['input'];
  bookingId?: InputMaybe<Scalars['String']['input']>;
  onlyOfferedStatus?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRetrieveBookingsByProfileArgs = {
  accessToken: Scalars['String']['input'];
};


export type QueryRetrieveEncodedBookingArgs = {
  token: Scalars['String']['input'];
};


export type QueryRetrieveEncryptedBookingArgs = {
  token: Scalars['String']['input'];
};


export type QueryReturnFlightsSearchArgs = {
  input?: InputMaybe<ReturnFlightSearchFilterInput>;
};


export type QuerySailingArgs = {
  filters?: InputMaybe<Scalars['String']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  sailDate?: InputMaybe<Scalars['String']['input']>;
  viewedPrice?: InputMaybe<Scalars['Float']['input']>;
  viewedSuperCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchPackageCodeByCruiseInfoArgs = {
  sailDate: Scalars['String']['input'];
  shipCode: Scalars['String']['input'];
};


export type QuerySearchSailingByBookingInfoArgs = {
  sailDate: Scalars['String']['input'];
  shipCode: Scalars['String']['input'];
};


export type QuerySearchSailingsArgs = {
  includeSoldOutSailings?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<DateRangeInput>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryShipArgs = {
  shipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStateroomArgs = {
  input: StateroomInput;
};


export type QueryTargetedOffersArgs = {
  datetime?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  loyaltyID?: InputMaybe<Scalars['String']['input']>;
  qualifiers?: InputMaybe<Scalars['String']['input']>;
  shipCode?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVariationByPencilBannerIdArgs = {
  datetime?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<PencilBannerLocale>;
  pencilBannerId?: InputMaybe<Scalars['ID']['input']>;
};

export type RetrieveBookingInput = {
  application?: InputMaybe<AplicationSource>;
  bookingAccessToken?: InputMaybe<Scalars['String']['input']>;
  bookingId: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  sailDate: Scalars['String']['input'];
  shipCode: Scalars['String']['input'];
};

export type RetrieveBookingPayload = {
  __typename?: 'RetrieveBookingPayload';
  booking?: Maybe<Booking>;
  token?: Maybe<Scalars['String']['output']>;
};

export type ReturnFlightSearchFilterInput = {
  bookingID?: InputMaybe<Scalars['String']['input']>;
  /** [Optional] Filter results by cabin class using a cabin code */
  cabinCode?: InputMaybe<Scalars['String']['input']>;
  /** [Required] Correlation id of matching flights from departure search */
  correlationID: Scalars['String']['input'];
  guests?: InputMaybe<Array<InputMaybe<HeldConfirmGuestInput>>>;
  /** [Required] Hash key of specific flight from departure search */
  hashKey: Scalars['String']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
};

export type Sailing = {
  __typename?: 'Sailing';
  bestPromotion?: Maybe<Promotion>;
  bookingLink?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['FullDate']['output']>;
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itinerary?: Maybe<Itinerary>;
  lowestStateroomClassPrice?: Maybe<StateroomClassPrice>;
  productViewLink?: Maybe<Scalars['String']['output']>;
  sailDate?: Maybe<Scalars['FullDate']['output']>;
  startDate?: Maybe<Scalars['FullDate']['output']>;
  stateroomClassPricing?: Maybe<Array<Maybe<StateroomClassPrice>>>;
  status?: Maybe<SailingStatus>;
  taxesAndFees?: Maybe<Price>;
  taxesAndFeesIncluded?: Maybe<Scalars['Boolean']['output']>;
};

export type SailingByBookingResponse = {
  __typename?: 'SailingByBookingResponse';
  name?: Maybe<Scalars['String']['output']>;
  totalNights?: Maybe<Scalars['Int']['output']>;
};

export type SailingQualifiers = {
  promoId?: InputMaybe<Scalars['String']['input']>;
};

export enum SailingStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Sailed = 'SAILED',
  SoldOut = 'SOLD_OUT'
}

export type SearchSailingsResponse = {
  __typename?: 'SearchSailingsResponse';
  dateRange?: Maybe<DateRange>;
  shipSailings?: Maybe<Array<Maybe<ShipSailing>>>;
};

export type Ship = {
  __typename?: 'Ship';
  code: Scalars['String']['output'];
  media?: Maybe<Media>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stateroomClasses instead. */
  stateroomCategories?: Maybe<Array<Maybe<StateroomClass>>>;
  stateroomClasses?: Maybe<Array<Maybe<StateroomClass>>>;
};

export type ShipBrowseFlight = {
  __typename?: 'ShipBrowseFlight';
  sailing?: Maybe<FlightSailing>;
  validDates?: Maybe<DateRange>;
};

export type ShipSailing = {
  __typename?: 'ShipSailing';
  sailingDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shipCode?: Maybe<Scalars['String']['output']>;
  shipName?: Maybe<Scalars['String']['output']>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Stateroom = {
  __typename?: 'Stateroom';
  accessible?: Maybe<Scalars['Boolean']['output']>;
  deck?: Maybe<Deck>;
  image?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  position?: Maybe<StateroomPosition>;
  stateroomCategory?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StateroomCategory = {
  __typename?: 'StateroomCategory';
  id?: Maybe<Scalars['ID']['output']>;
};

export type StateroomClass = {
  __typename?: 'StateroomClass';
  content?: Maybe<StateroomClassContent>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StateroomClassContent = {
  __typename?: 'StateroomClassContent';
  amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  area?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  maxCapacity?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
  superCategory?: Maybe<Scalars['String']['output']>;
};

export type StateroomClassPrice = {
  __typename?: 'StateroomClassPrice';
  category?: Maybe<StateroomCategory>;
  price?: Maybe<Price>;
  priceVariation?: Maybe<Variation>;
  stateroomClass?: Maybe<StateroomClass>;
};

export type StateroomInput = {
  cabinNumber: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  sailDate: Scalars['FullDate']['input'];
  shipCode: Scalars['String']['input'];
};

export enum StateroomPosition {
  Af = 'AF',
  Fw = 'FW',
  Ms = 'MS'
}

export type Stops = {
  __typename?: 'Stops';
  nonStop?: Maybe<Scalars['Boolean']['output']>;
  oneStop?: Maybe<Scalars['Boolean']['output']>;
  twoStops?: Maybe<Scalars['Boolean']['output']>;
};

export type TargetPages = {
  __typename?: 'TargetPages';
  excluded?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  included?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  experienceFragment?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type Tour = {
  __typename?: 'Tour';
  code?: Maybe<Scalars['String']['output']>;
  days?: Maybe<Array<Maybe<Day>>>;
  duration?: Maybe<Scalars['Int']['output']>;
};

export type TransferData = {
  __typename?: 'TransferData';
  componentType?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transferCode?: Maybe<Scalars['String']['output']>;
  transferDescription?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum Type {
  BalanceDue = 'BALANCE_DUE',
  CabinTariff = 'CABIN_TARIFF',
  DepositAmount = 'DEPOSIT_AMOUNT',
  Discount = 'DISCOUNT',
  DiscountedCruiseFare = 'DISCOUNTED_CRUISE_FARE',
  GrossTotals = 'GROSS_TOTALS',
  OriginalCruiseFare = 'ORIGINAL_CRUISE_FARE',
  PaymentsApplied = 'PAYMENTS_APPLIED',
  PortCharges = 'PORT_CHARGES',
  TaxesAndFees = 'TAXES_AND_FEES',
  TaxesFeesGrouping = 'TAXES_FEES_GROUPING',
  TotalCharges = 'TOTAL_CHARGES'
}

export type UiAttributes = {
  __typename?: 'UIAttributes';
  contentAlignment?: Maybe<Scalars['String']['output']>;
  countdownBackgroundColor?: Maybe<Scalars['String']['output']>;
  countdownTextColor?: Maybe<Scalars['String']['output']>;
  ctaColor?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaTextColor?: Maybe<Scalars['String']['output']>;
  extendedBackgroundColor?: Maybe<Scalars['String']['output']>;
  extendedColorsEnabled?: Maybe<Scalars['Boolean']['output']>;
  extendedTextColor?: Maybe<Scalars['String']['output']>;
  gradientStartColor?: Maybe<Scalars['String']['output']>;
  gradientTransitionColor?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type UpdateGuestInformationInput = {
  /** Date of bith of the guest (YYYY-MM-DD) */
  birthDate?: InputMaybe<Scalars['FullDate']['input']>;
  cas?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  /** Represents the position of the guest in the guest array. ESL returns it as rph */
  index: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  skipRepricingCheck?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  travelDocument?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradesData = {
  __typename?: 'UpgradesData';
  bookingId?: Maybe<Scalars['String']['output']>;
  offerUrl?: Maybe<Scalars['String']['output']>;
  upgradeEligible?: Maybe<Scalars['Boolean']['output']>;
};

export enum UrgencyFlagType {
  Book = 'book',
  BookLand = 'book_land',
  View = 'view',
  Watch = 'watch'
}

export type UrgencyFlags = {
  __typename?: 'UrgencyFlags';
  count?: Maybe<Scalars['Int']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<UrgencyFlagType>;
};

export type Variation = {
  __typename?: 'Variation';
  priceDifference?: Maybe<Price>;
  priceDrop?: Maybe<Scalars['Boolean']['output']>;
};

export type WarningMessage = {
  __typename?: 'WarningMessage';
  code: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ProfileBookingData = {
  __typename?: 'profileBookingData';
  bookingId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['FullDate']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  offerExpirationDate?: Maybe<Scalars['FullDate']['output']>;
  sailDate?: Maybe<Scalars['FullDate']['output']>;
  shipCode?: Maybe<Scalars['String']['output']>;
  shipName?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BestPromotionForMarketQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  displayQualifier?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BestPromotionForMarketQuery = { __typename?: 'Query', bestPromotionForMarket?: { __typename?: 'Promotion', id: string, endDate?: string | null, countdownEnabled?: boolean | null, extended?: boolean | null, lockup?: { __typename?: 'Lockup', desktop?: { __typename?: 'PromotionImage', relativePath?: string | null } | null, mobile?: { __typename?: 'PromotionImage', relativePath?: string | null } | null } | null, perks?: Array<{ __typename?: 'BooleanPerk', qualifier?: string | null, name?: string | null, description?: Array<string | null> | null } | { __typename?: 'DynamicPricePerk', search?: string | null, name?: string | null, description?: Array<string | null> | null, defaultPrice?: { __typename?: 'Price', value?: number | null, currency?: { __typename?: 'Currency', name?: string | null, symbol?: string | null } | null } | null } | { __typename?: 'PercentOffPerk', target?: string | null, percent?: number | null, qualifier?: string | null, name?: string | null, description?: Array<string | null> | null } | { __typename?: 'PricePerk', qualifier?: string | null, name?: string | null, description?: Array<string | null> | null, price?: { __typename?: 'Price', value?: number | null, currency?: { __typename?: 'Currency', code: string } | null } | null } | null> | null } | null };

export type PromotionsQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
  displayQualifier?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PromotionsQuery = { __typename?: 'Query', promotions?: Array<{ __typename?: 'Promotion', campaignId?: string | null, id: string, status?: string | null, title?: string | null, description?: string | null, code?: string | null, startDate?: string | null, endDate?: string | null, enabled?: boolean | null, countdownEnabled?: boolean | null, extended?: boolean | null, criteria?: Array<{ __typename?: 'Criteria', ships?: Array<string | null> | null, destination?: Array<string | null> | null, cabinClass?: Array<string | null> | null, departurePort?: Array<string | null> | null, nights?: Array<string | null> | null, startDate?: Array<{ __typename?: 'CriteriaDateRange', start?: string | null, end?: string | null } | null> | null } | null> | null, lockup?: { __typename?: 'Lockup', desktop?: { __typename?: 'PromotionImage', relativePath?: string | null } | null, mobile?: { __typename?: 'PromotionImage', relativePath?: string | null } | null } | null, perks?: Array<{ __typename?: 'BooleanPerk', qualifier?: string | null, name?: string | null, description?: Array<string | null> | null } | { __typename?: 'DynamicPricePerk', search?: string | null, name?: string | null, description?: Array<string | null> | null, defaultPrice?: { __typename?: 'Price', value?: number | null, currency?: { __typename?: 'Currency', name?: string | null, symbol?: string | null } | null } | null } | { __typename?: 'PercentOffPerk', target?: string | null, percent?: number | null, qualifier?: string | null, name?: string | null, description?: Array<string | null> | null } | { __typename?: 'PricePerk', qualifier?: string | null, name?: string | null, description?: Array<string | null> | null, price?: { __typename?: 'Price', value?: number | null, currency?: { __typename?: 'Currency', code: string } | null } | null } | null> | null } | null> | null };

export type TargetedOffersQueryVariables = Exact<{
  loyaltyID?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  displayQualifier?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TargetedOffersQuery = { __typename?: 'Query', targetedOffers?: Array<{ __typename?: 'Promotion', campaignId?: string | null, id: string, code?: string | null, couponCode?: string | null, type?: PromotionType | null, title?: string | null, startDate?: string | null, endDate?: string | null, description?: string | null, fareCodes?: Array<string | null> | null, criteria?: Array<{ __typename?: 'Criteria', ships?: Array<string | null> | null, startDate?: Array<{ __typename?: 'CriteriaDateRange', start?: string | null, end?: string | null } | null> | null } | null> | null, termsAndConditions?: { __typename?: 'TermsAndConditions', link?: string | null, experienceFragment?: string | null } | null, perks?: Array<{ __typename: 'BooleanPerk', qualifier?: string | null, name?: string | null, description?: Array<string | null> | null } | { __typename: 'DynamicPricePerk', search?: string | null, name?: string | null, description?: Array<string | null> | null, defaultPrice?: { __typename?: 'Price', value?: number | null, currency?: { __typename?: 'Currency', code: string } | null } | null } | { __typename: 'PercentOffPerk', target?: string | null, percent?: number | null, qualifier?: string | null, name?: string | null, description?: Array<string | null> | null } | { __typename: 'PricePerk', qualifier?: string | null, name?: string | null, description?: Array<string | null> | null, price?: { __typename?: 'Price', value?: number | null, currency?: { __typename?: 'Currency', code: string } | null } | null } | null> | null } | null> | null };

export type GetAllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCountriesQuery = { __typename?: 'Query', allCountries?: Array<{ __typename?: 'Country', code: string, name?: string | null } | null> | null };

export type LocaleQueryVariables = Exact<{
  market?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isoAlpha2Code?: InputMaybe<Scalars['String']['input']>;
}>;


export type LocaleQuery = { __typename?: 'Query', locale?: { __typename?: 'Locale', id: string, code?: string | null, path?: string | null, language?: { __typename?: 'Language', code: string } | null, currency?: { __typename?: 'Currency', code: string } | null, market?: { __typename?: 'Market', code: string } | null, country?: { __typename?: 'Country', code: string, name?: string | null, isoAlpha2Code?: string | null, phoneNumber?: Array<string | null> | null, office?: { __typename?: 'Office', code: string } | null, currencies?: Array<{ __typename?: 'Currency', code: string } | null> | null } | null } | null };


export const BestPromotionForMarketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bestPromotionForMarket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayQualifier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bestPromotionForMarket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"lockup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desktop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countdownEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"extended"}},{"kind":"Field","name":{"kind":"Name","value":"perks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"order"},{"kind":"EnumValue","value":"price"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"displayQualifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayQualifier"}}}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanPerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DynamicPricePerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"}},{"kind":"Field","name":{"kind":"Name","value":"defaultPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PercentOffPerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricePerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BestPromotionForMarketQuery, BestPromotionForMarketQueryVariables>;
export const PromotionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Promotions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayQualifier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"criteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ships"}},{"kind":"Field","name":{"kind":"Name","value":"destination"}},{"kind":"Field","name":{"kind":"Name","value":"cabinClass"}},{"kind":"Field","name":{"kind":"Name","value":"departurePort"}},{"kind":"Field","name":{"kind":"Name","value":"nights"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lockup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desktop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countdownEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"extended"}},{"kind":"Field","name":{"kind":"Name","value":"perks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"order"},{"kind":"EnumValue","value":"price"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"displayQualifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayQualifier"}}}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanPerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DynamicPricePerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"}},{"kind":"Field","name":{"kind":"Name","value":"defaultPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PercentOffPerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricePerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PromotionsQuery, PromotionsQueryVariables>;
export const TargetedOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"targetedOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayQualifier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetedOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyID"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"BEST","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"couponCode"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fareCodes"}},{"kind":"Field","name":{"kind":"Name","value":"criteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ships"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"experienceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"perks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"order"},{"kind":"EnumValue","value":"price"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"displayQualifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayQualifier"}}}]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanPerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DynamicPricePerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"}},{"kind":"Field","name":{"kind":"Name","value":"defaultPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PercentOffPerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricePerk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TargetedOffersQuery, TargetedOffersQueryVariables>;
export const GetAllCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAllCountriesQuery, GetAllCountriesQueryVariables>;
export const LocaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Locale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"market"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isoAlpha2Code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"market"},"value":{"kind":"Variable","name":{"kind":"Name","value":"market"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"isoAlpha2Code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isoAlpha2Code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isoAlpha2Code"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"office"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LocaleQuery, LocaleQueryVariables>;